import { createSlice } from '@reduxjs/toolkit';
import { fetchSupremeEssentials } from '../thunks/trackThunks';

const initialState = {
    items: [],
    isSupremeEssentialsLoading: false,
    error: null,
};

const supremeEssentialsSlice = createSlice({
    name: 'supremeEssentials',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSupremeEssentials.pending, (state) => {
                state.isSupremeEssentialsLoading = true;
                state.error = null;
            })
            .addCase(fetchSupremeEssentials.fulfilled, (state, action) => {
                state.isSupremeEssentialsLoading = false;
                state.items = action.payload;
            })
            .addCase(fetchSupremeEssentials.rejected, (state, action) => {
                state.isSupremeEssentialsLoading = false;
                state.error = action.payload;
            });
    }
});

export default supremeEssentialsSlice.reducer;